
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stock-list/complete",
      function () {
        return require("private-next-pages/stock-list/complete/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stock-list/complete"])
      });
    }
  